//DO NOT MODIFY THIS MANUALLY!!!!
//Generated by running npm generate:colors

const colors = {
  colorPrimary: "var(--color-primary)",
  colorPrimaryLighter: "var(--color-primary-lighter)",
  colorSecondary: "var(--color-secondary)",
  textStrong: "var(--text-strong)",
  text: "var(--text)",
  textOnPrimary: "var(--text-on-primary)",
  background: "var(--background)",
  backgroundSecondary: "var(--background-secondary)",
  warning: "var(--warning)",
  subscriptionBackground: "var(--subscription-background)",
  textSecondary: "var(--text-secondary)",
  trustedBackground: "var(--trusted-background)",
  ctaGradientStart: "var(--cta-gradient-start)",
  ctaGradientEnd: "var(--cta-gradient-end)",
  bannerBackground: "var(--banner-background)",
  bannerCtaBackground: "var(--banner-cta-background)",
  bannerTimerBackground: "var(--banner-timer-background)",
  bannerTimerBorder: "var(--banner-timer-border)",
  bannerCtaTitle: "var(--banner-cta-title)",
  bannerImageText: "var(--banner-image-text)",
  bannerContentBackground: "var(--banner-content-background)",
  promoBackground: "var(--promo-background)",
  onboardingGradientStart: "var(--onboarding-gradient-start)",
  onboardingGradientEnd: "var(--onboarding-gradient-end)",
  importBadgeBackground: "var(--import-badge-background)",
  pricingSelectedStroke: "var(--pricing-selected-stroke)",
  colorPrimaryFaded: "var(--color-primary-faded)",
  colorPopupBackground: "var(--color-popup-background)",
  colorPopup: "var(--color-popup)",
  colorInfoButtonBorder: "var(--color-info-button-border)",
  colorInfoButtonContent: "var(--color-info-button-content)",
  colorInfoButtonText: "var(--color-info-button-text)",
  colorSubscriptionTextSelected: "var(--color-subscription-text-selected)",
  colorSubscriptionTextSelectedSecondary:
    "var(--color-subscription-text-selected-secondary)",
  colorSubscriptionTextUnselected: "var(--color-subscription-text-unselected)",
  colorSubscriptionTextUnselectedSecondary:
    "var(--color-subscription-text-unselected-secondary)",
  colorBannerSecondary: "var(--color-banner-secondary)",
  premiumFeatureText: "var(--premium-feature-text)",
  colorNotification: "var(--color-notification)",
  colorPrimaryLight: "var(--color-primary-light)",
  colorReturnTicketStroke: "var(--color-return-ticket-stroke)",
  featurePremiumHeaderBackground: "var(--feature-premium-header-background)",
  featureUltimateHeaderBackground: "var(--feature-ultimate-header-background)",
  featurePremiumBackground: "var(--feature-premium-background)",
  featureUltimateBackground: "var(--feature-ultimate-background)",
  separatorLight: "var(--separator-light)",
  backgroundModal: "var(--background-modal)",
  colorPromoSpecial: "var(--color-promo-special)",
  lifetimeDisclaimerBg: "var(--lifetime-disclaimer-bg)",
  lifetimeDisclaimerBorder: "var(--lifetime-disclaimer-border)",
  colorUltimate: "var(--color-ultimate)",
}

export default colors
